import React, { useState, useEffect } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import LabelTag from "../../../reusebale/label";
import ButtonTag from "../../../reusebale/button";
import AddUnitPopup from "../../../popup/unitpopup";
import AddPropertyPopup from "../../../popup/addPropertyPopup";

import BaseUrl from "../../../../constants/BaseUrl";
import { ChevronDown } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import * as LeaseAction from "../../../../store/actions/lease/LeaseAction";

import { ShowError } from "../../../../utils/ToasFunction";

const Terms = ({
  onPropertySelect,
  selectedProperty,
  onUnitSelect,
  selectedUnit,
  formData,
}) => {
  const dispatch = useDispatch();

  const [allProperties, setAllProperties] = useState([]);
  const [allUnits, setAllUnits] = useState([]);
  const { leaseData, leaseUpdate, isRenewal } = useSelector(
    (state) => state.lease
  );


  const [showUnitPopUp, setShowUnitpopUp] = useState(false);
  const [showPropertyPopUp, setshowPropertypopUp] = useState(false);

  const { loginSuccess } = useSelector((state) => state.auth);

  const GetAllProperties = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/property/getAllPropertiesbyLandlord/${loginSuccess?.user?._id}?status=active`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setAllProperties(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const GetUnitByPropertyId = (id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/property/getUnitByPropertyId/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          let availableUnits = [];
          const unit = result?.unitData?.unitData;
          for (const key in unit) {
            if (unit[key].occupied == false) {
              availableUnits.push(unit[key]);
            }
          }

          setAllUnits(availableUnits);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetAllProperties();
  }, []);

  const openPopup = () => {
    setShowUnitpopUp(true);
  };

  const closePopup = () => {
    setShowUnitpopUp(false);
  };

  const openPropertyPopup = () => {
    setshowPropertypopUp(true);
  };

  const closePropertyPopup = () => {
    setshowPropertypopUp(false);
  };

  useEffect(() => {
    if (leaseUpdate && formData.propertyInfo) {
      GetUnitByPropertyId(formData.propertyInfo._id);

      // GetUnitByPropertyId(formData.propertyInfo._id)
    }
  }, [leaseUpdate]);

  return (
    <div className="w-[60%] mx-auto h-full">
      <div className="text-center h-[10%]">
        <ParagraphTag
          content="Property"
          classes="text-darkColor font-popinsSemiBold text-lg"
        />
        <ParagraphTag
          content="Choose your desired property and unit."
          classes="text-darkColor/50 font-popinsMedium text-xs"
        />
      </div>

      <form className="overflow-y-scroll h-[80%] panelScroll px-1">
        <div className="flex justify-between mt-6">
          <div className="w-[49%]">
            <LabelTag
              name="Property"
              isStaric={false}
              classes="text-darkColor text-left !text-xs !font-popinsMedium"
            />
            <div
              className={`w-full bg-bgColor py-[10px] rounded-md text-sm px-3 flex justify-between ${
                isRenewal ? "cursor-not-allowed opacity-50" : "cursor-pointer"
              }`}
              onClick={isRenewal ? undefined : openPropertyPopup}
            >
              <p className="font-popinsRegular text-darkColor/40">
                {selectedProperty}
              </p>
              <ChevronDown color="#1A1A1A2D" size={18} />
            </div>
          </div>
          <div className="w-[49%]">
            <LabelTag
              name="Unit"
              isStaric={false}
              classes="text-darkColor !text-left !text-xs !font-popinsMedium"
            />
            <div
              className={`w-full bg-bgColor py-[10px] rounded-md text-sm px-3 flex justify-between ${
                isRenewal ? "cursor-not-allowed opacity-50" : "cursor-pointer"
              }`}
              onClick={isRenewal ? undefined : openPopup}
            >
              <p className="font-popinsRegular text-darkColor/40">
                {selectedUnit}
              </p>
              <ChevronDown color="#1A1A1A2D" size={18} />
            </div>
          </div>
        </div>
      </form>
      <div className="h-[10%] flex justify-center items-center">
        <div className="w-[50%]">
          <ButtonTag
            onSubmit={(e) => {
              e.preventDefault();

              if (!formData.propertyInfo || !formData.unitInfo) {
                ShowError("Please select a property and unit before proceeding.");
                return;
              }

              dispatch(LeaseAction.ChangePropertyCreateSteps(2));
            }}
            name="Next"
            classes="text-base text-center bg-themeColor text-white"
          />
        </div>
      </div>
      {showUnitPopUp && (
        <AddUnitPopup
          allUnits={allUnits}
          onClose={closePopup}
          onSelectUnit={(item) => {
            onUnitSelect(item);
            closePopup();
            // alert(JSON.stringify(on))
          }}
        />
      )}

      {showPropertyPopUp && (
        <AddPropertyPopup
          onSelect={(item) => {
            onPropertySelect(item);
            GetUnitByPropertyId(item._id);
          }}
          allProperties={allProperties}
          onClose={closePropertyPopup}
        />
      )}
    </div>
  );
};

export default Terms;
